<!--
 * @Author: your name
 * @Date: 2021-11-29 14:12:06
 * @LastEditTime: 2022-03-26 16:43:23
 * @LastEditors: Smart Chow
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \nqc-web-ui\src\components\MutipleDateSelect.vue
-->
<template>
  <section class="flex">
    <div
      class="w-date-editor w-range-editor w-input__inner w-date-editor--daterange w-range-editor--small"
    >
      <w-date-picker
        ref="datePicker1"
        v-model="showSelectValue"
        :value="showSelectValue"
        type="daterange"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :disabled="disabled"
        range-separator="至"
        :clearable="false"
        @change="changeSelectValue"
      >
      </w-date-picker>
    </div>
    <w-popover
      v-model="propoverShow"
      trigger="click"
      :visible-arrow="false"
      :disabled="disabled"
    >
      <div>
        <div class="w-date-picker__header--bordered">
          <span>已选条件:</span>
          <w-tag
            v-for="(tag, index) in selectTypes"
            :key="index"
            class="m-5"
            :closable="tag.type !== 'year'"
            @close="handleClose(index)"
          >
            {{ tag.type !== 'year' ? tag.label : `${tag.label}年` }}
          </w-tag>
        </div>
        <!-- 年份 -->
        <div class="flex mt-10">
          <label>年份：</label>
          <div class="w-date-picker__header">
            <button
              type="button"
              aria-label="前一年"
              class="w-picker-panel__icon-btn w-date-picker__prev-btn w-icon-triangle-left y-icon"
              style="margin-top: 2px"
              @click="preYear()"
            ></button>
            <span role="button" class="w-date-picker__header-label">
              {{ selectTypes[0].label }}
            </span>
            <button
              type="button"
              aria-label="后一年"
              class="w-picker-panel__icon-btn w-date-picker__next-btn w-icon-triangle-right y-icon"
              style="margin-top: 2px"
              @click="nextYear()"
            ></button>
          </div>
        </div>
        <div class="flex">
          <label>半年：</label>
          <div>
            <div class="w-picker-panel__content">
              <table class="w-month-table w-month-table--medium" style="">
                <tbody>
                  <tr>
                    <td
                      v-for="(item, index) in halfYearArr"
                      :key="index"
                      style="padding: 0"
                      :class="
                        selectTypeInfo.type === item.type &&
                        selectTypeInfo.value === item.value
                          ? 'today'
                          : ''
                      "
                      class="mr-10"
                      @click="getSelectedDate(item, 'halfYear')"
                    >
                      <div>
                        <a class="cell w100"
                          ><span>{{ item.label }}</span></a
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="flex">
          <label>季度：</label>
          <div>
            <div class="w-picker-panel__content">
              <table class="w-month-table w-month-table--medium" style="">
                <tbody>
                  <tr>
                    <td
                      v-for="(item, index) in seasonArr"
                      :key="index"
                      style="padding: 0"
                      :class="
                        selectTypeInfo.type === item.type &&
                        selectTypeInfo.value === item.value
                          ? 'today'
                          : ''
                      "
                      class="mr-10"
                      @click="getSelectedDate(item, 'season')"
                    >
                      <div>
                        <a class="cell w100"
                          ><span>{{ item.label }}</span></a
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="flex-baseline">
          <label class="wn-pt-15">月份：</label>
          <div>
            <div class="w-picker-panel__content">
              <table class="w-month-table w-month-table--medium" style="">
                <tbody>
                  <tr>
                    <td
                      v-for="(item, index) in monthArr.slice(0, 6)"
                      :key="index"
                      style="padding: 0"
                      :class="
                        selectTypeInfo.type === item.type &&
                        selectTypeInfo.value === item.value
                          ? 'today'
                          : ''
                      "
                      @click="getSelectedDate(item, 'month')"
                    >
                      <div>
                        <a class="cell w100"
                          ><span>{{ item.label }}</span></a
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      v-for="(item, index) in monthArr.slice(6)"
                      :key="index"
                      style="padding: 0"
                      :class="
                        selectTypeInfo.type === item.type &&
                        selectTypeInfo.value === item.value
                          ? 'today'
                          : ''
                      "
                      @click="getSelectedDate(item, 'month')"
                    >
                      <div>
                        <a class="cell w100"
                          ><span>{{ item.label }}</span></a
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="wn-fr mt-10">
          <w-button type="primary" size="mini" @click="confirmDate()"
            >确认</w-button
          >
          <w-button size="mini" @click="propoverShow = false">取消</w-button>
        </div>
      </div>
      <span slot="reference">
        <div class="ml-1">
          <i class="w-icon w-icon-date fs-16 pointer"></i>
        </div>
      </span>
    </w-popover>
  </section>
</template>
<script>
export default {
  name: 'MutipleDateSelect',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dictsList: [],
      showSelectValue: [],
      selectValue: [],
      selectTypeInfo: {},
      selectTypes: [
        {
          type: 'year',
          label: ''
        }
      ],
      halfYearArr: [
        {
          label: '上半年',
          type: 'halfYear',
          value: '01-01'
        },
        {
          label: '下半年',
          type: 'halfYear',
          value: '07-01'
        }
      ],
      seasonArr: [
        {
          label: '一季度',
          type: 'season',
          value: '01-01'
        },
        {
          label: '二季度',
          value: '04-01',
          type: 'season'
        },
        {
          label: '三季度',
          value: '07-01',
          type: 'season'
        },
        {
          label: '四季度',
          value: '10-01',
          type: 'season'
        }
      ],
      monthArr: [
        {
          label: '1月',
          type: 'month',
          value: '01-01'
        },
        {
          label: '2月',
          type: 'month',
          value: '02-01'
        },
        {
          label: '3月',
          type: 'month',
          value: '03-01'
        },
        {
          label: '4月',
          type: 'month',
          value: '04-01'
        },
        {
          label: '5月',
          type: 'month',
          value: '05-01'
        },
        {
          label: '6月',
          type: 'month',
          value: '06-01'
        },
        {
          label: '7月',
          type: 'month',
          value: '07-01'
        },
        {
          label: '8月',
          type: 'month',
          value: '08-01'
        },
        {
          label: '9月',
          type: 'month',
          value: '09-01'
        },
        {
          label: '10月',
          type: 'month',
          value: '10-01'
        },
        {
          label: '11月',
          type: 'month',
          value: '11-01'
        },
        {
          label: '12月',
          type: 'month',
          value: '12-01'
        }
      ],
      propoverShow: false
    }
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        if (newValue.length > 0) {
          this.showSelectValue = newValue
          this.selectValue = newValue
          this.selectTypes[0].label = this.dayjs(newValue[0]).format('YYYY')
        } else {
          this.initTime()
        }
      },
      deep: true
    }
  },
  created() {
    this.showSelectValue = JSON.parse(JSON.stringify(this.value))
    this.selectValue = JSON.parse(JSON.stringify(this.value))
    if (this.value.length === 0) {
      this.initTime()
    } else {
      this.selectTypes[0].label = this.dayjs(this.selectValue[0]).format('YYYY')
      let month = new Date().getMonth()
      this.selectTypeInfo = this.monthArr[month]
      this.selectTypes.push(this.selectTypeInfo)
    }
  },
  methods: {
    initTime() {
      if (!this.selectTypes[0].label) {
        this.selectTypes[0].label = this.dayjs().format('YYYY')
        let month = new Date().getMonth()
        this.selectTypeInfo = this.monthArr[month]
        this.selectTypes.push(this.selectTypeInfo)
        this.getSelectedDate(this.selectTypeInfo, 'month')
        this.showSelectValue = JSON.parse(JSON.stringify(this.selectValue))
      }
      this.confirmDate()
    },
    setStartTime(val) {
      this.selectValue[0] = val
      this.confirmDate()
    },
    setEndTime(val) {
      this.selectValue[1] = val
      this.confirmDate()
    },
    handleClose(index) {
      this.selectTypes.splice(index, 1)
      this.selectValue = [
        this.selectTypes[0].label + '-01-01',
        this.selectTypes[0].label + '-12-31'
      ]
      this.selectTypeInfo = {}
    },
    getSelectedDate(item, type) {
      this.selectTypeInfo = { ...item }
      this.selectTypes.splice(1, 1, item)
      let statTime = ''
      let endTime = ''
      switch (type) {
        case 'halfYear':
          statTime = this.selectTypes[0].label + '-' + item.value
          endTime = this.dayjs(this.selectTypes[0].label + '-' + item.value)
            .add(6, 'month')
            .subtract(1, 'day')
            .format('YYYY-MM-DD')
          this.selectValue = [statTime, endTime]
          break
        case 'season':
          statTime = this.selectTypes[0].label + '-' + item.value
          endTime = this.dayjs(this.selectTypes[0].label + '-' + item.value)
            .add(3, 'month')
            .subtract(1, 'day')
            .format('YYYY-MM-DD')
          this.selectValue = [statTime, endTime]
          break
        case 'month':
          // 年 + 月 + 日
          statTime = this.selectTypes[0].label + '-' + item.value
          endTime = this.dayjs(this.selectTypes[0].label + '-' + item.value)
            .endOf('month')
            .format('YYYY-MM-DD')
          this.selectValue = [statTime, endTime]
          break
      }
    },
    preYear() {
      this.selectTypes[0].label--
      let statTime =
        this.selectTypes[0].label +
        '-' +
        this.dayjs(this.selectValue[0]).format('MM-DD')
      let endTime =
        this.selectTypes[0].label +
        '-' +
        this.dayjs(this.selectValue[1]).format('MM-DD')
      this.selectValue = [statTime, endTime]
    },
    nextYear() {
      this.selectTypes[0].label++
      let statTime =
        this.selectTypes[0].label +
        '-' +
        this.dayjs(this.selectValue[0]).format('MM-DD')
      let endTime =
        this.selectTypes[0].label +
        '-' +
        this.dayjs(this.selectValue[1]).format('MM-DD')
      this.selectValue = [statTime, endTime]
    },
    confirmDate() {
      let val = []
      this.showSelectValue = JSON.parse(JSON.stringify(this.selectValue))
      val = [...this.showSelectValue]
      // 将时间调整为范围时间
      this.$emit('change', val)
      this.propoverShow = false
    },
    changeSelectValue(val) {
      this.$emit('change', val)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .w-date-picker__header,
.w-picker-panel__content {
  margin: 0;
}
/deep/.w-range-editor .w-range-input {
  width: 100%;
}
/deep/ .w-month-table {
  border-spacing: 0 5px;
}
/deep/ .w-range__icon {
  display: none;
}
/deep/ .w-range-input {
  padding: 0 18px 0 10px;
}
</style>
